import React, { Component } from "react";
//import '../../css/custom.css';

const Help = () => {
  return (
    <div className="right_col" role="main">
      <div className="x_panel">
        <div className="x_title">
          <h2>Overview</h2>
        </div>
        <p>
          After successfully logging in, the tabs to the left-hand side allow you to navigate different parts of your
          Clean Your List account: Email Verification, Dashboard, Pricing, Account Settings, Help, and Logout.{" "}
        </p>
        <ul>
          <li>
            Email Verification allows for bulk email and single email verification through list uploads and manual
            entry, respectively.
          </li>
          <li>
            Dashboard details verification activity over a single day, week, month, or quarter. It also displays
            remaining credits and email verification analytics.
          </li>
          <li>Pricing explains billing options. </li>
          <li>
            Account Settings allows you to add or edit General Information*, including first and last name, company
            name, mobile phone number, country, city, address, and zip code; update your password in Security; and see
            Payment History and add or update a credit card.
          </li>
          <li>Help takes you to the FAQ page.</li>
          <li>Logout signs you out of your account.</li>
        </ul>
        <p>
          <b>* </b>Please note that the email address linked to the account cannot be changed. If you need to update the
          email linked to the account or delete the account, please contact{" "}
          <a style={{ color: "#3366ff" }} href="mailto:info@mirabeltechnologies.com">
            info@mirabeltechnologies.com
          </a>
          .
        </p>
      </div>


      <div className="x_panel">
        <div className="x_title">
          <h2>Benefits of Email Verification</h2>
        </div>
        <p>
          The email verification process ensures that you are capturing and sending to valid email addresses. A valid
          address is one that is active and receiving mail. A few benefits of email verification include the following:
        </p>
        <ul>
          <li>Decrease hard bounce rate</li>
          <li>Increase email deliverability rate with 99 percent accuracy</li>
          <li>Update CRMs</li>
          <li>Adhere to all major Internet service provider requirements and achieve better sender reputation</li>
          <li>Reach your leads and customers</li>
        </ul>
      </div>

      
      <div className="x_panel">
      <div className="x_title">
        <h2>How It Works</h2>
      </div>
        <ol>
          <li>
            Create an account on{" "}
            <a style={{ color: "#3366ff" }} target="_blank" href="https://cleanyourlist.mirabeltechnologies.com">
              cleanyourlist.mirabeltechnologies.com
            </a>
            .
          </li>
          <li>
            Verify your account via email:
            <ol type="a">
              <li>
                If you don’t receive an email right away, please check all folders (Promotional, Social, Spam, Junk,
                Trash) to locate the email.
              </li>
              <li>
                If it still hasn’t arrived, double-check that your email address was spelled and formatted correctly.
              </li>
              <li>
                If you don’t receive an email at all, please try re-registering or contacting our system administrator
                at
                <a style={{ color: "#3366ff" }} href="mailto:info@mirabeltechnologies.com">
                  {" "}
                  info@mirabeltechnologies.com
                </a>
                .
              </li>
            </ol>
          </li>
          <li>
            Log in to upload your email list in an .XLS, .XLSX, .ODS, .CSV, or .TXT format for bulk list cleaning, or
            type one address at a time in the single email verification module.
          </li>
          <li>
            Each email address is automatically scanned for proper formatting, valid inboxes and email providers, and
            more.
          </li>
          <li>
            Clean Your List categorizes each email address: Valid, invalid, or unknown. We email you a new list, and you
            can download the new list on your Clean Your List account using the cloud with a downward arrow to the right
            of the screen. If you’re using the single email verification module, we’ll tell you this within seconds.
          </li>
        </ol>
      </div>


      
       <div className="x_panel">
       <div className="x_title">
        <h2>Results</h2>
      </div>
        <p>
          Clean Your List sorts email addresses into three main categories: valid, invalid, and unknown. A few
          subcategories help further distinguish each email address.
        </p>
        <table border="1">
          <thead>
            <tr>
              <th style={{ padding: 5, width: "33%", textAlign: "center" }}>Category</th>
              <th style={{ padding: 5, width: "33%", textAlign: "center" }}>Description</th>
              <th style={{ padding: 5, width: "33%", textAlign: "center" }}>OK to Send ?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Valid</td>
              <td style={{ padding: 5, width: "33%" }}>Verified as an active email that is receiving messages.</td>
              <td style={{ padding: 5, width: "33%" }}>Yes</td>
            </tr>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Invalid</td>
              <td style={{ padding: 5, width: "33%" }}>
                Verified as an inactive email that is not receiving messages.
              </td>
              <td style={{ padding: 5, width: "33%" }}>No</td>
            </tr>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Unknown Scored</td>
              <td style={{ padding: 5, width: "33%" }}>
                The email address is <i>estimated</i> to be valid due to relevant data from other digital sources.
              </td>
              <td style={{ padding: 5, width: "33%" }}>Depends</td>
            </tr>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Unknown</td>
              <td style={{ padding: 5, width: "33%" }}>
                The email address seems to be valid, but the server likely cannot be reached to <i>confirm</i> a valid
                address.
              </td>
              <td style={{ padding: 5, width: "33%" }}>Depends</td>
            </tr>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Invalid email format</td>
              <td style={{ padding: 5, width: "33%" }}>
                The email address is not formatted properly (name@server.com)
              </td>
              <td style={{ padding: 5, width: "33%" }}>No</td>
            </tr>
            <tr>
              <td style={{ padding: 5, width: "33%" }}>Duplicates</td>
              <td style={{ padding: 5, width: "33%" }}>
                The email address is found more than once in bulk email verification.
              </td>
              <td style={{ padding: 5, width: "33%" }}>Remove duplicate address before sending</td>
            </tr>
          </tbody>
        </table>
      </div>

      
      
      <div className="x_panel">
      <div className="x_title">
        <h2>Pricing</h2>
      </div>
        <p>
          We offer 1,500 free credits to use upon registration. Each free credit equates to one email address
          verification. Credits can be used for either the bulk email or single email verification.
        </p>
        <p>
          In order to prevent abuse of this system, we require a valid credit card to be kept on file. The credit card
          will be charged only after the free credits have been used. Free and paid credits do not expire, cannot be
          transferred between accounts, or used for other email verification tools.
        </p>
        <p>
          Clean Your List offers two payment plans: Monthly subscriptions and one-time purchases. Monthly subscriptions
          are recurring charges and sorted by number of credits. For example, if you’d like a subscription to verify
          5,000 to 10,000 emails per month, we charge a recurring $39.
        </p>
        <p>
          <b>This works out to less than a penny per email!</b>
        </p>

        <div>
        <p>One-time purchases are just that: a one-time charge to verify a certain number of email addresses.</p>
        <p>We accept the following online payment types:</p>
        <ul>
          <li>Visa </li>
          <li>MasterCard</li>
          <li>ACH</li>
          <li>Diners</li>
          <li>American Express</li>
          <li>Discover</li>
        </ul>
      </div>
      <div>
        <p>
          Once a payment is made, we will send you an email with a PDF invoice, and you can find a full Payment History
          in Account Settings. If you need to update credit card information, please contact
          <a style={{ color: "#3366ff" }} href="mailto:info@mirabeltechnologies.com">
            {" "}
            info@mirabeltechnologies.com
          </a>{" "}
          or visit Account Settings.
        </p>
      </div>
      </div>
      
    
    
      <div className="x_panel">
       <div className="x_title">
        <h2>Privacy</h2>
      </div>
        <p>
          Mirabel Technologies, The Magazine Manager, The Newspaper Manager, and Mirabel’s Marketing Manager will not
          store, sell, or reuse the data you input into our email verification tool, Clean Your List. Uploaded data will
          be automatically deleted after 90 days from the time of the upload. You may delete your data sooner than this
          at any time.
        </p>
        <p>
          Your login email may be used by Mirabel Technologies and/or any of our softwares mentioned above for
          marketing, communications, and/or sales purposes. You may unsubscribe from these email notifications at any
          time.
        </p>
        <p>
          For more information regarding our complete data privacy and protection, please view our{" "}
          <a style={{ color: "#3366ff" }} target="_blank" href="https://www.mirabeltechnologies.com/privacy-statement">
            company privacy policy
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help/HelpContainer.js